import React, { useEffect, useState } from 'react';
import AXIOSCONFIGMETHOD from '../../../../components/apiCall/axiosConfig';
import { webServiceUrl } from '../../../../components/apiCall/webserviceurl';
import Loading from '../../../../components/common/Loading';

function Food_timings({ program_id }) {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
const local = localStorage.getItem("school_code");
  const getData = async () => {
    try {
      setLoading(true);
      const resp = await AXIOSCONFIGMETHOD("POST", webServiceUrl.food_timing, {
        program_id: local
      });

      // console.log(resp?.data);
      setData(resp?.data || []);
    } catch (error) {
      console.error("Failed to fetch data", error);
    } finally {
      setTimeout(() => setLoading(false), 1000);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  return (
    <div>
      {loading
        ? <div className="py-5" style={{ height: "20vh" }}><Loading /></div>
        : <>
          <section className="max-w-7xl mx-auto px-6 py-12">
            <p className="subHeading my-3">
              Timing for Food and Refreshment
            </p>
            <p className="ihfc_text my-3">
              The table below outlines the scheduled timings for meals and refreshments. Please note that these timings may be subject to change based on directives from the host institute.
            </p>

            <table className="min-w-full table-auto border border-gray-300 text-center justify-center mx-auto">
              <thead className="bg-blue-100 text-gray-800">
                <tr>
                  <th className="border px-4 py-2">Meal</th>
                  <th className="border px-4 py-2">Timing</th>
                </tr>
              </thead>
              <tbody className="text-gray-700">
                {data.map((item, index) => (
                  <tr key={index}>
                    <td className="border px-4 py-2">{item.meal}</td>
                    <td className="border px-4 py-2">{item.timing}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </section>
        </>}
    </div>
  );
}

export default Food_timings;
